import entityContainerConnector from '~components/generic/entityContainerConnector';
import { SidebarContext } from '~components/sidebar/context/SidebarContext';

export default entityContainerConnector(SidebarContext);
